// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v6.32.1
// source: Journey.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "";

export enum JourneyStatus {
  JOURNEY_STATUS_NONE = 0,
  JOURNEY_STATUS_WAITING_TO_START = 1,
  JOURNEY_STATUS_STARTED = 2,
  JOURNEY_STATUS_ENDED = 3,
  UNRECOGNIZED = -1,
}

export function journeyStatusFromJSON(object: any): JourneyStatus {
  switch (object) {
    case 0:
    case "JOURNEY_STATUS_NONE":
      return JourneyStatus.JOURNEY_STATUS_NONE;
    case 1:
    case "JOURNEY_STATUS_WAITING_TO_START":
      return JourneyStatus.JOURNEY_STATUS_WAITING_TO_START;
    case 2:
    case "JOURNEY_STATUS_STARTED":
      return JourneyStatus.JOURNEY_STATUS_STARTED;
    case 3:
    case "JOURNEY_STATUS_ENDED":
      return JourneyStatus.JOURNEY_STATUS_ENDED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JourneyStatus.UNRECOGNIZED;
  }
}

export function journeyStatusToJSON(object: JourneyStatus): string {
  switch (object) {
    case JourneyStatus.JOURNEY_STATUS_NONE:
      return "JOURNEY_STATUS_NONE";
    case JourneyStatus.JOURNEY_STATUS_WAITING_TO_START:
      return "JOURNEY_STATUS_WAITING_TO_START";
    case JourneyStatus.JOURNEY_STATUS_STARTED:
      return "JOURNEY_STATUS_STARTED";
    case JourneyStatus.JOURNEY_STATUS_ENDED:
      return "JOURNEY_STATUS_ENDED";
    case JourneyStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum JourneyServiceType {
  JST_UNKNOWN = 0,
  JST_NORMAL = 1,
  JST_EXTRA = 2,
  JST_REINFORCEMENT = 3,
  JST_DEADRUN = 4,
  JST_TESTRUN = 5,
  JST_SHORTRUN = 6,
  JST_LEARNING = 7,
  /** JST_TOW - If multiple train wagons are in tow, the towed vehicle get this service */
  JST_TOW = 8,
  UNRECOGNIZED = -1,
}

export function journeyServiceTypeFromJSON(object: any): JourneyServiceType {
  switch (object) {
    case 0:
    case "JST_UNKNOWN":
      return JourneyServiceType.JST_UNKNOWN;
    case 1:
    case "JST_NORMAL":
      return JourneyServiceType.JST_NORMAL;
    case 2:
    case "JST_EXTRA":
      return JourneyServiceType.JST_EXTRA;
    case 3:
    case "JST_REINFORCEMENT":
      return JourneyServiceType.JST_REINFORCEMENT;
    case 4:
    case "JST_DEADRUN":
      return JourneyServiceType.JST_DEADRUN;
    case 5:
    case "JST_TESTRUN":
      return JourneyServiceType.JST_TESTRUN;
    case 6:
    case "JST_SHORTRUN":
      return JourneyServiceType.JST_SHORTRUN;
    case 7:
    case "JST_LEARNING":
      return JourneyServiceType.JST_LEARNING;
    case 8:
    case "JST_TOW":
      return JourneyServiceType.JST_TOW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JourneyServiceType.UNRECOGNIZED;
  }
}

export function journeyServiceTypeToJSON(object: JourneyServiceType): string {
  switch (object) {
    case JourneyServiceType.JST_UNKNOWN:
      return "JST_UNKNOWN";
    case JourneyServiceType.JST_NORMAL:
      return "JST_NORMAL";
    case JourneyServiceType.JST_EXTRA:
      return "JST_EXTRA";
    case JourneyServiceType.JST_REINFORCEMENT:
      return "JST_REINFORCEMENT";
    case JourneyServiceType.JST_DEADRUN:
      return "JST_DEADRUN";
    case JourneyServiceType.JST_TESTRUN:
      return "JST_TESTRUN";
    case JourneyServiceType.JST_SHORTRUN:
      return "JST_SHORTRUN";
    case JourneyServiceType.JST_LEARNING:
      return "JST_LEARNING";
    case JourneyServiceType.JST_TOW:
      return "JST_TOW";
    case JourneyServiceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum JourneyProgressStatus {
  JOURNEY_PROGRESS_UNASSIGNED = 0,
  JOURNEY_PROGRESS_WAITING_FOR_JOURNEY_START = 1,
  JOURNEY_PROGRESS_AT_FIRST_STOP = 2,
  JOURNEY_PROGRESS_BETWEEN_STOPS = 3,
  JOURNEY_PROGRESS_APPROACHING_STOP = 4,
  JOURNEY_PROGRESS_REACHED_STOP = 5,
  JOURNEY_PROGRESS_ARRIVED_STOP = 6,
  JOURNEY_PROGRESS_LEAVING_STOP = 7,
  JOURNEY_PROGRESS_OFF_ROUTE = 8,
  UNRECOGNIZED = -1,
}

export function journeyProgressStatusFromJSON(object: any): JourneyProgressStatus {
  switch (object) {
    case 0:
    case "JOURNEY_PROGRESS_UNASSIGNED":
      return JourneyProgressStatus.JOURNEY_PROGRESS_UNASSIGNED;
    case 1:
    case "JOURNEY_PROGRESS_WAITING_FOR_JOURNEY_START":
      return JourneyProgressStatus.JOURNEY_PROGRESS_WAITING_FOR_JOURNEY_START;
    case 2:
    case "JOURNEY_PROGRESS_AT_FIRST_STOP":
      return JourneyProgressStatus.JOURNEY_PROGRESS_AT_FIRST_STOP;
    case 3:
    case "JOURNEY_PROGRESS_BETWEEN_STOPS":
      return JourneyProgressStatus.JOURNEY_PROGRESS_BETWEEN_STOPS;
    case 4:
    case "JOURNEY_PROGRESS_APPROACHING_STOP":
      return JourneyProgressStatus.JOURNEY_PROGRESS_APPROACHING_STOP;
    case 5:
    case "JOURNEY_PROGRESS_REACHED_STOP":
      return JourneyProgressStatus.JOURNEY_PROGRESS_REACHED_STOP;
    case 6:
    case "JOURNEY_PROGRESS_ARRIVED_STOP":
      return JourneyProgressStatus.JOURNEY_PROGRESS_ARRIVED_STOP;
    case 7:
    case "JOURNEY_PROGRESS_LEAVING_STOP":
      return JourneyProgressStatus.JOURNEY_PROGRESS_LEAVING_STOP;
    case 8:
    case "JOURNEY_PROGRESS_OFF_ROUTE":
      return JourneyProgressStatus.JOURNEY_PROGRESS_OFF_ROUTE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JourneyProgressStatus.UNRECOGNIZED;
  }
}

export function journeyProgressStatusToJSON(object: JourneyProgressStatus): string {
  switch (object) {
    case JourneyProgressStatus.JOURNEY_PROGRESS_UNASSIGNED:
      return "JOURNEY_PROGRESS_UNASSIGNED";
    case JourneyProgressStatus.JOURNEY_PROGRESS_WAITING_FOR_JOURNEY_START:
      return "JOURNEY_PROGRESS_WAITING_FOR_JOURNEY_START";
    case JourneyProgressStatus.JOURNEY_PROGRESS_AT_FIRST_STOP:
      return "JOURNEY_PROGRESS_AT_FIRST_STOP";
    case JourneyProgressStatus.JOURNEY_PROGRESS_BETWEEN_STOPS:
      return "JOURNEY_PROGRESS_BETWEEN_STOPS";
    case JourneyProgressStatus.JOURNEY_PROGRESS_APPROACHING_STOP:
      return "JOURNEY_PROGRESS_APPROACHING_STOP";
    case JourneyProgressStatus.JOURNEY_PROGRESS_REACHED_STOP:
      return "JOURNEY_PROGRESS_REACHED_STOP";
    case JourneyProgressStatus.JOURNEY_PROGRESS_ARRIVED_STOP:
      return "JOURNEY_PROGRESS_ARRIVED_STOP";
    case JourneyProgressStatus.JOURNEY_PROGRESS_LEAVING_STOP:
      return "JOURNEY_PROGRESS_LEAVING_STOP";
    case JourneyProgressStatus.JOURNEY_PROGRESS_OFF_ROUTE:
      return "JOURNEY_PROGRESS_OFF_ROUTE";
    case JourneyProgressStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AssignmentServiceType {
  AST_UNKNOWN = 0,
  AST_NORMAL = 1,
  AST_EXTRA = 2,
  AST_REINFORCEMENT = 3,
  AST_TESTRUN = 4,
  AST_LEARNING = 5,
  /** AST_TOW - If multiple train wagons are in tow, the towed vehicle get this service */
  AST_TOW = 6,
  UNRECOGNIZED = -1,
}

export function assignmentServiceTypeFromJSON(object: any): AssignmentServiceType {
  switch (object) {
    case 0:
    case "AST_UNKNOWN":
      return AssignmentServiceType.AST_UNKNOWN;
    case 1:
    case "AST_NORMAL":
      return AssignmentServiceType.AST_NORMAL;
    case 2:
    case "AST_EXTRA":
      return AssignmentServiceType.AST_EXTRA;
    case 3:
    case "AST_REINFORCEMENT":
      return AssignmentServiceType.AST_REINFORCEMENT;
    case 4:
    case "AST_TESTRUN":
      return AssignmentServiceType.AST_TESTRUN;
    case 5:
    case "AST_LEARNING":
      return AssignmentServiceType.AST_LEARNING;
    case 6:
    case "AST_TOW":
      return AssignmentServiceType.AST_TOW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssignmentServiceType.UNRECOGNIZED;
  }
}

export function assignmentServiceTypeToJSON(object: AssignmentServiceType): string {
  switch (object) {
    case AssignmentServiceType.AST_UNKNOWN:
      return "AST_UNKNOWN";
    case AssignmentServiceType.AST_NORMAL:
      return "AST_NORMAL";
    case AssignmentServiceType.AST_EXTRA:
      return "AST_EXTRA";
    case AssignmentServiceType.AST_REINFORCEMENT:
      return "AST_REINFORCEMENT";
    case AssignmentServiceType.AST_TESTRUN:
      return "AST_TESTRUN";
    case AssignmentServiceType.AST_LEARNING:
      return "AST_LEARNING";
    case AssignmentServiceType.AST_TOW:
      return "AST_TOW";
    case AssignmentServiceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AssignmentSelectionType {
  ASSIGNMENT_SELECTION_TYPE_UNKNOWN = 0,
  ASSIGNMENT_SELECTION_TYPE_MANUAL = 1,
  ASSIGNMENT_SELECTION_TYPE_AUTOMATIC = 2,
  UNRECOGNIZED = -1,
}

export function assignmentSelectionTypeFromJSON(object: any): AssignmentSelectionType {
  switch (object) {
    case 0:
    case "ASSIGNMENT_SELECTION_TYPE_UNKNOWN":
      return AssignmentSelectionType.ASSIGNMENT_SELECTION_TYPE_UNKNOWN;
    case 1:
    case "ASSIGNMENT_SELECTION_TYPE_MANUAL":
      return AssignmentSelectionType.ASSIGNMENT_SELECTION_TYPE_MANUAL;
    case 2:
    case "ASSIGNMENT_SELECTION_TYPE_AUTOMATIC":
      return AssignmentSelectionType.ASSIGNMENT_SELECTION_TYPE_AUTOMATIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssignmentSelectionType.UNRECOGNIZED;
  }
}

export function assignmentSelectionTypeToJSON(object: AssignmentSelectionType): string {
  switch (object) {
    case AssignmentSelectionType.ASSIGNMENT_SELECTION_TYPE_UNKNOWN:
      return "ASSIGNMENT_SELECTION_TYPE_UNKNOWN";
    case AssignmentSelectionType.ASSIGNMENT_SELECTION_TYPE_MANUAL:
      return "ASSIGNMENT_SELECTION_TYPE_MANUAL";
    case AssignmentSelectionType.ASSIGNMENT_SELECTION_TYPE_AUTOMATIC:
      return "ASSIGNMENT_SELECTION_TYPE_AUTOMATIC";
    case AssignmentSelectionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AssignmentSegmentReason {
  ASR_NONE = 0,
  ASR_SHORTRUN = 1,
  ASR_SHORTRUN_TURNAROUND = 2,
  ASR_REINFORCE = 3,
  ASR_SLICED_ASSIGNMENT = 4,
  UNRECOGNIZED = -1,
}

export function assignmentSegmentReasonFromJSON(object: any): AssignmentSegmentReason {
  switch (object) {
    case 0:
    case "ASR_NONE":
      return AssignmentSegmentReason.ASR_NONE;
    case 1:
    case "ASR_SHORTRUN":
      return AssignmentSegmentReason.ASR_SHORTRUN;
    case 2:
    case "ASR_SHORTRUN_TURNAROUND":
      return AssignmentSegmentReason.ASR_SHORTRUN_TURNAROUND;
    case 3:
    case "ASR_REINFORCE":
      return AssignmentSegmentReason.ASR_REINFORCE;
    case 4:
    case "ASR_SLICED_ASSIGNMENT":
      return AssignmentSegmentReason.ASR_SLICED_ASSIGNMENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssignmentSegmentReason.UNRECOGNIZED;
  }
}

export function assignmentSegmentReasonToJSON(object: AssignmentSegmentReason): string {
  switch (object) {
    case AssignmentSegmentReason.ASR_NONE:
      return "ASR_NONE";
    case AssignmentSegmentReason.ASR_SHORTRUN:
      return "ASR_SHORTRUN";
    case AssignmentSegmentReason.ASR_SHORTRUN_TURNAROUND:
      return "ASR_SHORTRUN_TURNAROUND";
    case AssignmentSegmentReason.ASR_REINFORCE:
      return "ASR_REINFORCE";
    case AssignmentSegmentReason.ASR_SLICED_ASSIGNMENT:
      return "ASR_SLICED_ASSIGNMENT";
    case AssignmentSegmentReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface JourneyDigest {
  status?: JourneyStatus | undefined;
  journeyName?: string | undefined;
  lineName?:
    | string
    | undefined;
  /** The start time of this journey, seconds since epoch, UTC. */
  journeyStartTime?:
    | number
    | undefined;
  /** Destination displayed to passengers. */
  destination?: string | undefined;
  via?: string | undefined;
  destination2?: string | undefined;
  via2?: string | undefined;
  journeyId?: string | undefined;
  lineId?: string | undefined;
  routeId?: string | undefined;
  ticketTariffId?:
    | string
    | undefined;
  /** Original traffic data destination. */
  journeyDestination?: string | undefined;
  journeyServiceType?: JourneyServiceType | undefined;
}

export interface JourneyInfo {
  digest?: JourneyDigest | undefined;
  stops: string[];
}

export interface JourneyProgress {
  status?: JourneyProgressStatus | undefined;
  journeyId?: string | undefined;
  indexInJourney?: number | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  currentSpeed?: number | undefined;
  timetableDeviation?: number | undefined;
  journeyName?: string | undefined;
  lineName?: string | undefined;
  lineId?: string | undefined;
  routeId?: string | undefined;
  linkLength?: number | undefined;
  distanceToNextStop?: number | undefined;
  altitude?: number | undefined;
  journeyServiceType?: JourneyServiceType | undefined;
}

export interface Stop {
  areaName?:
    | string
    | undefined;
  /** index in JourneyInfo.stops */
  indexInJourney?:
    | number
    | undefined;
  /** A,B,C or similar */
  stopPointName?: string | undefined;
  areaId?: string | undefined;
  stopPointId?: string | undefined;
  ticketZoneIds: string[];
}

export interface Offroute {
  offroute?: boolean | undefined;
}

export interface StopPressed {
  stopPressed?: boolean | undefined;
}

export interface DoorOpen {
  doorOpen?: boolean | undefined;
}

export interface AtStop {
  atStop?: boolean | undefined;
}

export interface Assignment {
  name?: string | undefined;
  blockId?:
    | string
    | undefined;
  /** The start time of this assignment, seconds since epoch, UTC. */
  startTime?: number | undefined;
  journeyId?: string | undefined;
  journeyName?: string | undefined;
  indexInBlock?: number | undefined;
  journeyStartTime?: number | undefined;
  serviceType?: AssignmentServiceType | undefined;
  selectionType?: AssignmentSelectionType | undefined;
  dutyId?: string | undefined;
  segmentReason?: AssignmentSegmentReason | undefined;
  segmentStart?: number | undefined;
  segmentEnd?: number | undefined;
  unboundAssignmentLabel?: string | undefined;
  unboundAssignmentSessionStart?:
    | number
    | undefined;
  /** Offset from timetable. Used for reinforcing vehicles for example. */
  timeOffsetSeconds?: number | undefined;
}

function createBaseJourneyDigest(): JourneyDigest {
  return {
    status: 0,
    journeyName: "",
    lineName: "",
    journeyStartTime: 0,
    destination: "",
    via: "",
    destination2: "",
    via2: "",
    journeyId: "",
    lineId: "",
    routeId: "",
    ticketTariffId: "",
    journeyDestination: "",
    journeyServiceType: 0,
  };
}

export const JourneyDigest: MessageFns<JourneyDigest> = {
  encode(message: JourneyDigest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== undefined && message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.journeyName !== undefined && message.journeyName !== "") {
      writer.uint32(18).string(message.journeyName);
    }
    if (message.lineName !== undefined && message.lineName !== "") {
      writer.uint32(26).string(message.lineName);
    }
    if (message.journeyStartTime !== undefined && message.journeyStartTime !== 0) {
      writer.uint32(32).uint32(message.journeyStartTime);
    }
    if (message.destination !== undefined && message.destination !== "") {
      writer.uint32(42).string(message.destination);
    }
    if (message.via !== undefined && message.via !== "") {
      writer.uint32(50).string(message.via);
    }
    if (message.destination2 !== undefined && message.destination2 !== "") {
      writer.uint32(58).string(message.destination2);
    }
    if (message.via2 !== undefined && message.via2 !== "") {
      writer.uint32(66).string(message.via2);
    }
    if (message.journeyId !== undefined && message.journeyId !== "") {
      writer.uint32(74).string(message.journeyId);
    }
    if (message.lineId !== undefined && message.lineId !== "") {
      writer.uint32(82).string(message.lineId);
    }
    if (message.routeId !== undefined && message.routeId !== "") {
      writer.uint32(98).string(message.routeId);
    }
    if (message.ticketTariffId !== undefined && message.ticketTariffId !== "") {
      writer.uint32(106).string(message.ticketTariffId);
    }
    if (message.journeyDestination !== undefined && message.journeyDestination !== "") {
      writer.uint32(114).string(message.journeyDestination);
    }
    if (message.journeyServiceType !== undefined && message.journeyServiceType !== 0) {
      writer.uint32(120).int32(message.journeyServiceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JourneyDigest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJourneyDigest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.journeyName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lineName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.journeyStartTime = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.destination = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.via = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.destination2 = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.via2 = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.journeyId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.lineId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.routeId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.ticketTariffId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.journeyDestination = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.journeyServiceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JourneyDigest {
    return {
      status: isSet(object.status) ? journeyStatusFromJSON(object.status) : 0,
      journeyName: isSet(object.journeyName) ? globalThis.String(object.journeyName) : "",
      lineName: isSet(object.lineName) ? globalThis.String(object.lineName) : "",
      journeyStartTime: isSet(object.journeyStartTime) ? globalThis.Number(object.journeyStartTime) : 0,
      destination: isSet(object.destination) ? globalThis.String(object.destination) : "",
      via: isSet(object.via) ? globalThis.String(object.via) : "",
      destination2: isSet(object.destination2) ? globalThis.String(object.destination2) : "",
      via2: isSet(object.via2) ? globalThis.String(object.via2) : "",
      journeyId: isSet(object.journeyId) ? globalThis.String(object.journeyId) : "",
      lineId: isSet(object.lineId) ? globalThis.String(object.lineId) : "",
      routeId: isSet(object.routeId) ? globalThis.String(object.routeId) : "",
      ticketTariffId: isSet(object.ticketTariffId) ? globalThis.String(object.ticketTariffId) : "",
      journeyDestination: isSet(object.journeyDestination) ? globalThis.String(object.journeyDestination) : "",
      journeyServiceType: isSet(object.journeyServiceType) ? journeyServiceTypeFromJSON(object.journeyServiceType) : 0,
    };
  },

  toJSON(message: JourneyDigest): unknown {
    const obj: any = {};
    if (message.status !== undefined && message.status !== 0) {
      obj.status = journeyStatusToJSON(message.status);
    }
    if (message.journeyName !== undefined && message.journeyName !== "") {
      obj.journeyName = message.journeyName;
    }
    if (message.lineName !== undefined && message.lineName !== "") {
      obj.lineName = message.lineName;
    }
    if (message.journeyStartTime !== undefined && message.journeyStartTime !== 0) {
      obj.journeyStartTime = Math.round(message.journeyStartTime);
    }
    if (message.destination !== undefined && message.destination !== "") {
      obj.destination = message.destination;
    }
    if (message.via !== undefined && message.via !== "") {
      obj.via = message.via;
    }
    if (message.destination2 !== undefined && message.destination2 !== "") {
      obj.destination2 = message.destination2;
    }
    if (message.via2 !== undefined && message.via2 !== "") {
      obj.via2 = message.via2;
    }
    if (message.journeyId !== undefined && message.journeyId !== "") {
      obj.journeyId = message.journeyId;
    }
    if (message.lineId !== undefined && message.lineId !== "") {
      obj.lineId = message.lineId;
    }
    if (message.routeId !== undefined && message.routeId !== "") {
      obj.routeId = message.routeId;
    }
    if (message.ticketTariffId !== undefined && message.ticketTariffId !== "") {
      obj.ticketTariffId = message.ticketTariffId;
    }
    if (message.journeyDestination !== undefined && message.journeyDestination !== "") {
      obj.journeyDestination = message.journeyDestination;
    }
    if (message.journeyServiceType !== undefined && message.journeyServiceType !== 0) {
      obj.journeyServiceType = journeyServiceTypeToJSON(message.journeyServiceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JourneyDigest>, I>>(base?: I): JourneyDigest {
    return JourneyDigest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JourneyDigest>, I>>(object: I): JourneyDigest {
    const message = createBaseJourneyDigest();
    message.status = object.status ?? 0;
    message.journeyName = object.journeyName ?? "";
    message.lineName = object.lineName ?? "";
    message.journeyStartTime = object.journeyStartTime ?? 0;
    message.destination = object.destination ?? "";
    message.via = object.via ?? "";
    message.destination2 = object.destination2 ?? "";
    message.via2 = object.via2 ?? "";
    message.journeyId = object.journeyId ?? "";
    message.lineId = object.lineId ?? "";
    message.routeId = object.routeId ?? "";
    message.ticketTariffId = object.ticketTariffId ?? "";
    message.journeyDestination = object.journeyDestination ?? "";
    message.journeyServiceType = object.journeyServiceType ?? 0;
    return message;
  },
};

function createBaseJourneyInfo(): JourneyInfo {
  return { digest: undefined, stops: [] };
}

export const JourneyInfo: MessageFns<JourneyInfo> = {
  encode(message: JourneyInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.digest !== undefined) {
      JourneyDigest.encode(message.digest, writer.uint32(10).fork()).join();
    }
    for (const v of message.stops) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JourneyInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJourneyInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.digest = JourneyDigest.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stops.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JourneyInfo {
    return {
      digest: isSet(object.digest) ? JourneyDigest.fromJSON(object.digest) : undefined,
      stops: globalThis.Array.isArray(object?.stops) ? object.stops.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: JourneyInfo): unknown {
    const obj: any = {};
    if (message.digest !== undefined) {
      obj.digest = JourneyDigest.toJSON(message.digest);
    }
    if (message.stops?.length) {
      obj.stops = message.stops;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JourneyInfo>, I>>(base?: I): JourneyInfo {
    return JourneyInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JourneyInfo>, I>>(object: I): JourneyInfo {
    const message = createBaseJourneyInfo();
    message.digest = (object.digest !== undefined && object.digest !== null)
      ? JourneyDigest.fromPartial(object.digest)
      : undefined;
    message.stops = object.stops?.map((e) => e) || [];
    return message;
  },
};

function createBaseJourneyProgress(): JourneyProgress {
  return {
    status: 0,
    journeyId: "",
    indexInJourney: 0,
    latitude: 0,
    longitude: 0,
    currentSpeed: 0,
    timetableDeviation: 0,
    journeyName: "",
    lineName: "",
    lineId: "",
    routeId: "",
    linkLength: 0,
    distanceToNextStop: 0,
    altitude: 0,
    journeyServiceType: 0,
  };
}

export const JourneyProgress: MessageFns<JourneyProgress> = {
  encode(message: JourneyProgress, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== undefined && message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.journeyId !== undefined && message.journeyId !== "") {
      writer.uint32(18).string(message.journeyId);
    }
    if (message.indexInJourney !== undefined && message.indexInJourney !== 0) {
      writer.uint32(24).uint32(message.indexInJourney);
    }
    if (message.latitude !== undefined && message.latitude !== 0) {
      writer.uint32(33).double(message.latitude);
    }
    if (message.longitude !== undefined && message.longitude !== 0) {
      writer.uint32(41).double(message.longitude);
    }
    if (message.currentSpeed !== undefined && message.currentSpeed !== 0) {
      writer.uint32(49).double(message.currentSpeed);
    }
    if (message.timetableDeviation !== undefined && message.timetableDeviation !== 0) {
      writer.uint32(56).sint32(message.timetableDeviation);
    }
    if (message.journeyName !== undefined && message.journeyName !== "") {
      writer.uint32(66).string(message.journeyName);
    }
    if (message.lineName !== undefined && message.lineName !== "") {
      writer.uint32(74).string(message.lineName);
    }
    if (message.lineId !== undefined && message.lineId !== "") {
      writer.uint32(82).string(message.lineId);
    }
    if (message.routeId !== undefined && message.routeId !== "") {
      writer.uint32(90).string(message.routeId);
    }
    if (message.linkLength !== undefined && message.linkLength !== 0) {
      writer.uint32(96).uint32(message.linkLength);
    }
    if (message.distanceToNextStop !== undefined && message.distanceToNextStop !== 0) {
      writer.uint32(104).uint32(message.distanceToNextStop);
    }
    if (message.altitude !== undefined && message.altitude !== 0) {
      writer.uint32(113).double(message.altitude);
    }
    if (message.journeyServiceType !== undefined && message.journeyServiceType !== 0) {
      writer.uint32(120).int32(message.journeyServiceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JourneyProgress {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJourneyProgress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.journeyId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.indexInJourney = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.currentSpeed = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.timetableDeviation = reader.sint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.journeyName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.lineName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.lineId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.routeId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.linkLength = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.distanceToNextStop = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 113) {
            break;
          }

          message.altitude = reader.double();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.journeyServiceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JourneyProgress {
    return {
      status: isSet(object.status) ? journeyProgressStatusFromJSON(object.status) : 0,
      journeyId: isSet(object.journeyId) ? globalThis.String(object.journeyId) : "",
      indexInJourney: isSet(object.indexInJourney) ? globalThis.Number(object.indexInJourney) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      currentSpeed: isSet(object.currentSpeed) ? globalThis.Number(object.currentSpeed) : 0,
      timetableDeviation: isSet(object.timetableDeviation) ? globalThis.Number(object.timetableDeviation) : 0,
      journeyName: isSet(object.journeyName) ? globalThis.String(object.journeyName) : "",
      lineName: isSet(object.lineName) ? globalThis.String(object.lineName) : "",
      lineId: isSet(object.lineId) ? globalThis.String(object.lineId) : "",
      routeId: isSet(object.routeId) ? globalThis.String(object.routeId) : "",
      linkLength: isSet(object.linkLength) ? globalThis.Number(object.linkLength) : 0,
      distanceToNextStop: isSet(object.distanceToNextStop) ? globalThis.Number(object.distanceToNextStop) : 0,
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : 0,
      journeyServiceType: isSet(object.journeyServiceType) ? journeyServiceTypeFromJSON(object.journeyServiceType) : 0,
    };
  },

  toJSON(message: JourneyProgress): unknown {
    const obj: any = {};
    if (message.status !== undefined && message.status !== 0) {
      obj.status = journeyProgressStatusToJSON(message.status);
    }
    if (message.journeyId !== undefined && message.journeyId !== "") {
      obj.journeyId = message.journeyId;
    }
    if (message.indexInJourney !== undefined && message.indexInJourney !== 0) {
      obj.indexInJourney = Math.round(message.indexInJourney);
    }
    if (message.latitude !== undefined && message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== undefined && message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.currentSpeed !== undefined && message.currentSpeed !== 0) {
      obj.currentSpeed = message.currentSpeed;
    }
    if (message.timetableDeviation !== undefined && message.timetableDeviation !== 0) {
      obj.timetableDeviation = Math.round(message.timetableDeviation);
    }
    if (message.journeyName !== undefined && message.journeyName !== "") {
      obj.journeyName = message.journeyName;
    }
    if (message.lineName !== undefined && message.lineName !== "") {
      obj.lineName = message.lineName;
    }
    if (message.lineId !== undefined && message.lineId !== "") {
      obj.lineId = message.lineId;
    }
    if (message.routeId !== undefined && message.routeId !== "") {
      obj.routeId = message.routeId;
    }
    if (message.linkLength !== undefined && message.linkLength !== 0) {
      obj.linkLength = Math.round(message.linkLength);
    }
    if (message.distanceToNextStop !== undefined && message.distanceToNextStop !== 0) {
      obj.distanceToNextStop = Math.round(message.distanceToNextStop);
    }
    if (message.altitude !== undefined && message.altitude !== 0) {
      obj.altitude = message.altitude;
    }
    if (message.journeyServiceType !== undefined && message.journeyServiceType !== 0) {
      obj.journeyServiceType = journeyServiceTypeToJSON(message.journeyServiceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JourneyProgress>, I>>(base?: I): JourneyProgress {
    return JourneyProgress.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JourneyProgress>, I>>(object: I): JourneyProgress {
    const message = createBaseJourneyProgress();
    message.status = object.status ?? 0;
    message.journeyId = object.journeyId ?? "";
    message.indexInJourney = object.indexInJourney ?? 0;
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.currentSpeed = object.currentSpeed ?? 0;
    message.timetableDeviation = object.timetableDeviation ?? 0;
    message.journeyName = object.journeyName ?? "";
    message.lineName = object.lineName ?? "";
    message.lineId = object.lineId ?? "";
    message.routeId = object.routeId ?? "";
    message.linkLength = object.linkLength ?? 0;
    message.distanceToNextStop = object.distanceToNextStop ?? 0;
    message.altitude = object.altitude ?? 0;
    message.journeyServiceType = object.journeyServiceType ?? 0;
    return message;
  },
};

function createBaseStop(): Stop {
  return { areaName: "", indexInJourney: 0, stopPointName: "", areaId: "", stopPointId: "", ticketZoneIds: [] };
}

export const Stop: MessageFns<Stop> = {
  encode(message: Stop, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.areaName !== undefined && message.areaName !== "") {
      writer.uint32(10).string(message.areaName);
    }
    if (message.indexInJourney !== undefined && message.indexInJourney !== 0) {
      writer.uint32(16).uint32(message.indexInJourney);
    }
    if (message.stopPointName !== undefined && message.stopPointName !== "") {
      writer.uint32(26).string(message.stopPointName);
    }
    if (message.areaId !== undefined && message.areaId !== "") {
      writer.uint32(34).string(message.areaId);
    }
    if (message.stopPointId !== undefined && message.stopPointId !== "") {
      writer.uint32(42).string(message.stopPointId);
    }
    for (const v of message.ticketZoneIds) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Stop {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.areaName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.indexInJourney = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.stopPointName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.areaId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.stopPointId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ticketZoneIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Stop {
    return {
      areaName: isSet(object.areaName) ? globalThis.String(object.areaName) : "",
      indexInJourney: isSet(object.indexInJourney) ? globalThis.Number(object.indexInJourney) : 0,
      stopPointName: isSet(object.stopPointName) ? globalThis.String(object.stopPointName) : "",
      areaId: isSet(object.areaId) ? globalThis.String(object.areaId) : "",
      stopPointId: isSet(object.stopPointId) ? globalThis.String(object.stopPointId) : "",
      ticketZoneIds: globalThis.Array.isArray(object?.ticketZoneIds)
        ? object.ticketZoneIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: Stop): unknown {
    const obj: any = {};
    if (message.areaName !== undefined && message.areaName !== "") {
      obj.areaName = message.areaName;
    }
    if (message.indexInJourney !== undefined && message.indexInJourney !== 0) {
      obj.indexInJourney = Math.round(message.indexInJourney);
    }
    if (message.stopPointName !== undefined && message.stopPointName !== "") {
      obj.stopPointName = message.stopPointName;
    }
    if (message.areaId !== undefined && message.areaId !== "") {
      obj.areaId = message.areaId;
    }
    if (message.stopPointId !== undefined && message.stopPointId !== "") {
      obj.stopPointId = message.stopPointId;
    }
    if (message.ticketZoneIds?.length) {
      obj.ticketZoneIds = message.ticketZoneIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Stop>, I>>(base?: I): Stop {
    return Stop.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Stop>, I>>(object: I): Stop {
    const message = createBaseStop();
    message.areaName = object.areaName ?? "";
    message.indexInJourney = object.indexInJourney ?? 0;
    message.stopPointName = object.stopPointName ?? "";
    message.areaId = object.areaId ?? "";
    message.stopPointId = object.stopPointId ?? "";
    message.ticketZoneIds = object.ticketZoneIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseOffroute(): Offroute {
  return { offroute: false };
}

export const Offroute: MessageFns<Offroute> = {
  encode(message: Offroute, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.offroute !== undefined && message.offroute !== false) {
      writer.uint32(8).bool(message.offroute);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Offroute {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOffroute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.offroute = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Offroute {
    return { offroute: isSet(object.offroute) ? globalThis.Boolean(object.offroute) : false };
  },

  toJSON(message: Offroute): unknown {
    const obj: any = {};
    if (message.offroute !== undefined && message.offroute !== false) {
      obj.offroute = message.offroute;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Offroute>, I>>(base?: I): Offroute {
    return Offroute.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Offroute>, I>>(object: I): Offroute {
    const message = createBaseOffroute();
    message.offroute = object.offroute ?? false;
    return message;
  },
};

function createBaseStopPressed(): StopPressed {
  return { stopPressed: false };
}

export const StopPressed: MessageFns<StopPressed> = {
  encode(message: StopPressed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stopPressed !== undefined && message.stopPressed !== false) {
      writer.uint32(8).bool(message.stopPressed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopPressed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopPressed();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.stopPressed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopPressed {
    return { stopPressed: isSet(object.stopPressed) ? globalThis.Boolean(object.stopPressed) : false };
  },

  toJSON(message: StopPressed): unknown {
    const obj: any = {};
    if (message.stopPressed !== undefined && message.stopPressed !== false) {
      obj.stopPressed = message.stopPressed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopPressed>, I>>(base?: I): StopPressed {
    return StopPressed.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopPressed>, I>>(object: I): StopPressed {
    const message = createBaseStopPressed();
    message.stopPressed = object.stopPressed ?? false;
    return message;
  },
};

function createBaseDoorOpen(): DoorOpen {
  return { doorOpen: false };
}

export const DoorOpen: MessageFns<DoorOpen> = {
  encode(message: DoorOpen, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.doorOpen !== undefined && message.doorOpen !== false) {
      writer.uint32(8).bool(message.doorOpen);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DoorOpen {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDoorOpen();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.doorOpen = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DoorOpen {
    return { doorOpen: isSet(object.doorOpen) ? globalThis.Boolean(object.doorOpen) : false };
  },

  toJSON(message: DoorOpen): unknown {
    const obj: any = {};
    if (message.doorOpen !== undefined && message.doorOpen !== false) {
      obj.doorOpen = message.doorOpen;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DoorOpen>, I>>(base?: I): DoorOpen {
    return DoorOpen.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DoorOpen>, I>>(object: I): DoorOpen {
    const message = createBaseDoorOpen();
    message.doorOpen = object.doorOpen ?? false;
    return message;
  },
};

function createBaseAtStop(): AtStop {
  return { atStop: false };
}

export const AtStop: MessageFns<AtStop> = {
  encode(message: AtStop, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.atStop !== undefined && message.atStop !== false) {
      writer.uint32(8).bool(message.atStop);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AtStop {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAtStop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.atStop = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AtStop {
    return { atStop: isSet(object.atStop) ? globalThis.Boolean(object.atStop) : false };
  },

  toJSON(message: AtStop): unknown {
    const obj: any = {};
    if (message.atStop !== undefined && message.atStop !== false) {
      obj.atStop = message.atStop;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AtStop>, I>>(base?: I): AtStop {
    return AtStop.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AtStop>, I>>(object: I): AtStop {
    const message = createBaseAtStop();
    message.atStop = object.atStop ?? false;
    return message;
  },
};

function createBaseAssignment(): Assignment {
  return {
    name: "",
    blockId: "",
    startTime: 0,
    journeyId: "",
    journeyName: "",
    indexInBlock: 0,
    journeyStartTime: 0,
    serviceType: 0,
    selectionType: 0,
    dutyId: "",
    segmentReason: 0,
    segmentStart: 0,
    segmentEnd: 0,
    unboundAssignmentLabel: "",
    unboundAssignmentSessionStart: 0,
    timeOffsetSeconds: 0,
  };
}

export const Assignment: MessageFns<Assignment> = {
  encode(message: Assignment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined && message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.blockId !== undefined && message.blockId !== "") {
      writer.uint32(18).string(message.blockId);
    }
    if (message.startTime !== undefined && message.startTime !== 0) {
      writer.uint32(24).uint32(message.startTime);
    }
    if (message.journeyId !== undefined && message.journeyId !== "") {
      writer.uint32(34).string(message.journeyId);
    }
    if (message.journeyName !== undefined && message.journeyName !== "") {
      writer.uint32(42).string(message.journeyName);
    }
    if (message.indexInBlock !== undefined && message.indexInBlock !== 0) {
      writer.uint32(48).int32(message.indexInBlock);
    }
    if (message.journeyStartTime !== undefined && message.journeyStartTime !== 0) {
      writer.uint32(56).uint32(message.journeyStartTime);
    }
    if (message.serviceType !== undefined && message.serviceType !== 0) {
      writer.uint32(64).int32(message.serviceType);
    }
    if (message.selectionType !== undefined && message.selectionType !== 0) {
      writer.uint32(72).int32(message.selectionType);
    }
    if (message.dutyId !== undefined && message.dutyId !== "") {
      writer.uint32(82).string(message.dutyId);
    }
    if (message.segmentReason !== undefined && message.segmentReason !== 0) {
      writer.uint32(96).int32(message.segmentReason);
    }
    if (message.segmentStart !== undefined && message.segmentStart !== 0) {
      writer.uint32(104).int32(message.segmentStart);
    }
    if (message.segmentEnd !== undefined && message.segmentEnd !== 0) {
      writer.uint32(112).int32(message.segmentEnd);
    }
    if (message.unboundAssignmentLabel !== undefined && message.unboundAssignmentLabel !== "") {
      writer.uint32(122).string(message.unboundAssignmentLabel);
    }
    if (message.unboundAssignmentSessionStart !== undefined && message.unboundAssignmentSessionStart !== 0) {
      writer.uint32(128).uint32(message.unboundAssignmentSessionStart);
    }
    if (message.timeOffsetSeconds !== undefined && message.timeOffsetSeconds !== 0) {
      writer.uint32(136).int32(message.timeOffsetSeconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Assignment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.blockId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.startTime = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.journeyId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.journeyName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.indexInBlock = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.journeyStartTime = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.serviceType = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.selectionType = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.dutyId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.segmentReason = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.segmentStart = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.segmentEnd = reader.int32();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.unboundAssignmentLabel = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.unboundAssignmentSessionStart = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.timeOffsetSeconds = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Assignment {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      blockId: isSet(object.blockId) ? globalThis.String(object.blockId) : "",
      startTime: isSet(object.startTime) ? globalThis.Number(object.startTime) : 0,
      journeyId: isSet(object.journeyId) ? globalThis.String(object.journeyId) : "",
      journeyName: isSet(object.journeyName) ? globalThis.String(object.journeyName) : "",
      indexInBlock: isSet(object.indexInBlock) ? globalThis.Number(object.indexInBlock) : 0,
      journeyStartTime: isSet(object.journeyStartTime) ? globalThis.Number(object.journeyStartTime) : 0,
      serviceType: isSet(object.serviceType) ? assignmentServiceTypeFromJSON(object.serviceType) : 0,
      selectionType: isSet(object.selectionType) ? assignmentSelectionTypeFromJSON(object.selectionType) : 0,
      dutyId: isSet(object.dutyId) ? globalThis.String(object.dutyId) : "",
      segmentReason: isSet(object.segmentReason) ? assignmentSegmentReasonFromJSON(object.segmentReason) : 0,
      segmentStart: isSet(object.segmentStart) ? globalThis.Number(object.segmentStart) : 0,
      segmentEnd: isSet(object.segmentEnd) ? globalThis.Number(object.segmentEnd) : 0,
      unboundAssignmentLabel: isSet(object.unboundAssignmentLabel)
        ? globalThis.String(object.unboundAssignmentLabel)
        : "",
      unboundAssignmentSessionStart: isSet(object.unboundAssignmentSessionStart)
        ? globalThis.Number(object.unboundAssignmentSessionStart)
        : 0,
      timeOffsetSeconds: isSet(object.timeOffsetSeconds) ? globalThis.Number(object.timeOffsetSeconds) : 0,
    };
  },

  toJSON(message: Assignment): unknown {
    const obj: any = {};
    if (message.name !== undefined && message.name !== "") {
      obj.name = message.name;
    }
    if (message.blockId !== undefined && message.blockId !== "") {
      obj.blockId = message.blockId;
    }
    if (message.startTime !== undefined && message.startTime !== 0) {
      obj.startTime = Math.round(message.startTime);
    }
    if (message.journeyId !== undefined && message.journeyId !== "") {
      obj.journeyId = message.journeyId;
    }
    if (message.journeyName !== undefined && message.journeyName !== "") {
      obj.journeyName = message.journeyName;
    }
    if (message.indexInBlock !== undefined && message.indexInBlock !== 0) {
      obj.indexInBlock = Math.round(message.indexInBlock);
    }
    if (message.journeyStartTime !== undefined && message.journeyStartTime !== 0) {
      obj.journeyStartTime = Math.round(message.journeyStartTime);
    }
    if (message.serviceType !== undefined && message.serviceType !== 0) {
      obj.serviceType = assignmentServiceTypeToJSON(message.serviceType);
    }
    if (message.selectionType !== undefined && message.selectionType !== 0) {
      obj.selectionType = assignmentSelectionTypeToJSON(message.selectionType);
    }
    if (message.dutyId !== undefined && message.dutyId !== "") {
      obj.dutyId = message.dutyId;
    }
    if (message.segmentReason !== undefined && message.segmentReason !== 0) {
      obj.segmentReason = assignmentSegmentReasonToJSON(message.segmentReason);
    }
    if (message.segmentStart !== undefined && message.segmentStart !== 0) {
      obj.segmentStart = Math.round(message.segmentStart);
    }
    if (message.segmentEnd !== undefined && message.segmentEnd !== 0) {
      obj.segmentEnd = Math.round(message.segmentEnd);
    }
    if (message.unboundAssignmentLabel !== undefined && message.unboundAssignmentLabel !== "") {
      obj.unboundAssignmentLabel = message.unboundAssignmentLabel;
    }
    if (message.unboundAssignmentSessionStart !== undefined && message.unboundAssignmentSessionStart !== 0) {
      obj.unboundAssignmentSessionStart = Math.round(message.unboundAssignmentSessionStart);
    }
    if (message.timeOffsetSeconds !== undefined && message.timeOffsetSeconds !== 0) {
      obj.timeOffsetSeconds = Math.round(message.timeOffsetSeconds);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Assignment>, I>>(base?: I): Assignment {
    return Assignment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Assignment>, I>>(object: I): Assignment {
    const message = createBaseAssignment();
    message.name = object.name ?? "";
    message.blockId = object.blockId ?? "";
    message.startTime = object.startTime ?? 0;
    message.journeyId = object.journeyId ?? "";
    message.journeyName = object.journeyName ?? "";
    message.indexInBlock = object.indexInBlock ?? 0;
    message.journeyStartTime = object.journeyStartTime ?? 0;
    message.serviceType = object.serviceType ?? 0;
    message.selectionType = object.selectionType ?? 0;
    message.dutyId = object.dutyId ?? "";
    message.segmentReason = object.segmentReason ?? 0;
    message.segmentStart = object.segmentStart ?? 0;
    message.segmentEnd = object.segmentEnd ?? 0;
    message.unboundAssignmentLabel = object.unboundAssignmentLabel ?? "";
    message.unboundAssignmentSessionStart = object.unboundAssignmentSessionStart ?? 0;
    message.timeOffsetSeconds = object.timeOffsetSeconds ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
